export default class BrowserDetect {

    private readonly safari: boolean;
    private readonly iOS: boolean

    constructor() {
        this.safari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
        this.iOS = [
                'iPad Simulator',
                'iPhone Simulator',
                'iPod Simulator',
                'iPad',
                'iPhone',
                'iPod'
            ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes("Mac") && "ontouchend" in document);

        if (this.isIOS()) {
            document.body.classList.add('ios')
        }

        if (this.isSafari()) {
            document.body.classList.add('safari')
        }

        // this is necessary, so that styles the get overridden by the ios body class,
        // that also have transitions on them, do not flash on page load
        document.body.classList.add('ignore-transitions');
        window.setTimeout(() => document.body.classList.remove('ignore-transitions'), 0);

    }

    public isIOS() {
        return this.iOS;
    }

    public isSafari() {
        return this.safari;
    }

}